import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User, BookOpen, Star, Settings } from 'lucide-react';
import './Navbar.css';

const Navbar = () => {
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <nav className="navbar">
            <div className="navbar-logo">
                <Link to="/" className="logo-link">orb</Link>
            </div>
            
            <div className="navbar-links">
                {/* <Link to="/vibes" className={`nav-link ${isActive('/vibes') ? 'active' : ''}`}>
                    <span className="nav-text">Vibes</span>
                </Link>
                <Link to="/journey" className={`nav-link ${isActive('/journey') ? 'active' : ''}`}>
                    <span className="nav-text">Journey</span>
                </Link>
                <Link to="/being" className={`nav-link ${isActive('/being') ? 'active' : ''}`}>
                    <span className="nav-text">Calling</span>
                </Link> */}
                <Link to="/settings" className={`nav-link ${isActive('/settings') ? 'active' : ''}`}>
                    <Settings size={16} />
                    <span className="nav-text">Settings</span>
                </Link>
            </div>
        </nav>
    );
};

export default Navbar;